import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import { AGENDA_VIEW, BOARD_VIEW, TABLE_VIEW } from '../../helpers/board/resolveBoardView';

/**
 * De weergaven in de volgorde waarin ze op het scherm staan.
 *
 * Eén lijst en niet drie geschreven knoppen: de knoppen waren letterlijke
 * kopieën van elkaar, en bij een derde weergave is dat de plek waar er één
 * achterblijft.
 * AI-CONTEXT: See docs/pitfalls.md#ui-sidebar-renders-its-menu-twice
 *
 * @type {Array<{value: string, label: string, Icon: Function}>}
 */
const VIEWS = [
    { value: TABLE_VIEW, label: 'Tabel', Icon: TableRowsOutlinedIcon },
    { value: BOARD_VIEW, label: 'Kolommen', Icon: ViewKanbanOutlinedIcon },
    { value: AGENDA_VIEW, label: 'Lijst en agenda', Icon: CalendarMonthOutlinedIcon },
];

/**
 * De keuze tussen de weergaven: icoontjes naast elkaar.
 *
 * Echte `<button>`s met een `aria-label`, niet klikbare icoontjes. Een icoon
 * zonder tekst zegt een schermlezer niets, en een `<div onClick>` is met het
 * toetsenbord niet te bereiken. `aria-pressed` vertelt welke aanstaat — dat is
 * wat de kleur visueel doet. `title` erbij voor de tooltip onder de muis; die
 * is een extraatje, niet de enige drager.
 * AI-CONTEXT: See docs/pitfalls.md#ui-hover-only-affordance-dies-on-mobile
 *
 * AI-CONTEXT: See docs/features/household-board-view.md
 *
 * De derde knop ('Lijst en agenda') hoort bij de module Huishoudens ('FIXtool');
 * standaard uit, zodat 'nog niet geladen' geen knop naar niets oplevert.
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 *
 * @param {object} props
 * @param {'table'|'board'|'agenda'} props.value - De weergave die nu aanstaat
 * @param {(view: 'table'|'board'|'agenda') => void} props.onChange - Krijgt de nieuwe keuze
 * @param {boolean} [props.showAgenda=false] - Of 'Lijst en agenda' erbij hoort (`householdPlanningEnabled`)
 * @returns {JSX.Element}
 */
const ViewSwitch = ({ value, onChange, showAgenda = false }) => (
    <div className="view-switch" role="group" aria-label="Weergave">
        {VIEWS.filter(({ value: view }) => showAgenda || view !== AGENDA_VIEW).map(({ value: view, label, Icon }) => (
            <button
                key={view}
                type="button"
                className={`view-switch__button${value === view ? ' view-switch__button--active' : ''}`}
                aria-pressed={value === view}
                aria-label={label}
                title={label}
                onClick={() => onChange(view)}
            >
                <Icon fontSize="small" />
            </button>
        ))}
    </div>
);

export default ViewSwitch;
